import CluesoAuth from '../src/cluesoAuth'

function App() {
  return (
    <div>
      <CluesoAuth/>
    </div>
  );
}

export default App;
